/******************************************************************************
 *
 * WorkCommentsCard
 *
 * Work Discussion
 *
 * Future
 *
 * • Mentions
 * • Attachments
 * • Voice Notes
 * • Emoji
 * • Edit
 * • Delete
 * • Reactions
 *
 ******************************************************************************/

import React, { useState } from "react";

export default function WorkCommentsCard({

    comments = [],

    onSend,

    onDelete

}) {

    const [message, setMessage] = useState("");

    function handleSend() {

        if (!message.trim()) {

            return;

        }

        onSend?.(message);

        setMessage("");

    }

    function initials(name = "") {

        return name
            .split(" ")
            .map(x => x[0])
            .join("")
            .substring(0, 2)
            .toUpperCase();

    }

    return (

        <div className="card border-0 shadow-sm">

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        💬 Comments

                    </h5>

                    <span className="badge bg-secondary">

                        {comments.length}

                    </span>

                </div>

            </div>

            <div
                className="card-body"
                style={{
                    maxHeight: 450,
                    overflowY: "auto"
                }}
            >

                {

                    comments.length === 0

                    ?

                    <div className="text-center py-5 text-muted">

                        No comments yet.

                    </div>

                    :

                    comments.map(comment => (

                        <div
                            key={comment.id}
                            className="d-flex mb-4"
                        >

                            <div
                                className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: 42,
                                    height: 42,
                                    fontWeight: 600
                                }}
                            >

                                {

                                    initials(

                                        comment.created_by

                                    )

                                }

                            </div>

                            <div className="flex-grow-1">

                                <div className="border rounded p-3">

                                    <div className="d-flex justify-content-between">

                                        <strong>

                                            {comment.created_by}

                                        </strong>

                                        <small className="text-muted">

                                            {comment.created_at}

                                        </small>

                                    </div>

                                    <div className="mt-2">

                                        {comment.comment}

                                    </div>

                                </div>

                            </div>

                        </div>

                    ))

                }

            </div>

            <div className="card-footer bg-white">

                <div className="input-group">

                    <input

                        type="text"

                        className="form-control"

                        placeholder="Write a comment..."

                        value={message}

                        onChange={(e) =>

                            setMessage(

                                e.target.value

                            )

                        }

                    />

                    <button
                        className="btn btn-primary"
                        onClick={handleSend}
                    >

                        Send

                    </button>

                </div>

            </div>

        </div>

    );

}